(() => {
  const panel = document.querySelector('#TimelineCart');
  if (!panel || window.TimelineCartUI) return;
  const body = panel.querySelector('[data-tl-cart-body]');
  const status = panel.querySelector('[data-tl-cart-status]');
  const foot = panel.querySelector('.tl-cart-foot');
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  let cart;
  let trigger;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cart?.currency || panel.dataset.currency || 'USD' }).format(cents / 100);
  const el = (tag, cls, text) => { const node = document.createElement(tag); if (cls) node.className = cls; if (text !== undefined) node.textContent = text; return node; };
  async function request(path, payload) {
    const response = await fetch(root + path, payload ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) } : { headers: { Accept: 'application/json' }, cache: 'no-store' });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Unable to update your cart. Please try again.');
    return data;
  }
  function setBusy(value) {
    busy = value;
    panel.setAttribute('aria-busy', String(value));
    panel.querySelectorAll('.tl-cart-body button').forEach(button => { button.disabled = value; });
    const checkout = panel.querySelector('.tl-cart-checkout');
    checkout.setAttribute('aria-disabled', String(value));
    checkout.tabIndex = value ? -1 : 0;
  }
  function open(opener) {
    trigger = opener || document.activeElement;
    if (!panel.open) panel.showModal();
    document.documentElement.classList.add('tl-cart-open');
  }
  function close() { panel.close(); }
  function render(data, focus) {
    cart = data;
    body.replaceChildren();
    panel.querySelector('[data-tl-cart-items]').textContent = `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`;
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = cart.item_count; node.closest('a')?.setAttribute('aria-label', `Shopping bag, ${cart.item_count} items`); });
    foot.hidden = !cart.item_count;
    panel.querySelector('[data-tl-cart-total]').textContent = money(cart.total_price);
    if (!cart.item_count) {
      body.append(el('p', 'tl-cart-empty', 'Your cart is empty.'));
      const keep = el('button', 'tl-cart-empty-button', 'Continue shopping');
      keep.type = 'button'; keep.addEventListener('click', close); body.append(keep);
    }
    for (const item of cart.items) {
      const row = el('article', 'tl-cart-item');
      if (item.image) { const img = el('img'); img.src = item.image; img.alt = item.product_title; img.width = 120; img.height = 150; row.append(img); }
      const detail = el('div', 'tl-cart-detail');
      detail.append(el('h3', '', item.product_title));
      if (item.variant_title && item.variant_title !== 'Default Title') detail.append(el('p', 'tl-cart-variant', item.variant_title));
      detail.append(el('p', 'tl-cart-mode', item.selling_plan_allocation?.selling_plan?.name || 'One-time purchase'));
      const bottom = el('div', 'tl-cart-item-bottom');
      const quantity = el('div', 'tl-cart-qty');
      for (const [name, text, value] of [['Decrease', '\u2212', item.quantity - 1], ['Increase', '+', item.quantity + 1]]) {
        const button = el('button', '', text); button.type = 'button'; button.setAttribute('aria-label', `${name} quantity for ${item.variant_title || item.product_title}`); button.dataset.key = item.key; button.dataset.action = name;
        button.addEventListener('click', () => change(item.key, value, name));
        quantity.append(button);
        if (name === 'Decrease') { const count = el('span', '', item.quantity); count.setAttribute('aria-label', `Quantity ${item.quantity}`); quantity.append(count); }
      }
      const remove = el('button', 'tl-cart-remove', 'Remove'); remove.type = 'button'; remove.setAttribute('aria-label', `Remove ${item.variant_title || item.product_title}`); remove.addEventListener('click', () => change(item.key, 0));
      bottom.append(quantity, remove); detail.append(bottom);
      row.append(detail, el('strong', 'tl-cart-line-price', money(item.final_line_price)));
      body.append(row);
    }
    if (focus) { const target = [...body.querySelectorAll('button')].find(n => n.dataset.key === focus.key && n.dataset.action === focus.action); (target || panel.querySelector('[data-tl-cart-close]')).focus(); }
  }
  async function change(key, quantity, action) {
    if (busy) return;
    setBusy(true); status.textContent = 'Updating cart...';
    try { render(await request('cart/change.js', { id: key, quantity }), { key, action }); status.textContent = 'Cart updated.'; }
    catch (error) { status.textContent = error.message; }
    finally { setBusy(false); }
  }
  async function show(opener) {
    if (busy) return;
    open(opener); setBusy(true); status.textContent = 'Loading cart...';
    try { render(await request('cart.js')); status.textContent = ''; }
    catch { status.textContent = 'Unable to load your cart. Close and reopen to try again.'; }
    finally { setBusy(false); }
  }
  async function add(form, opener) {
    if (busy) return;
    const id = form.querySelector('[name="id"]:checked')?.value;
    const quantity = Number(form.querySelector('[name="quantity"]').value);
    const buttons = [...document.querySelectorAll(`[form="${form.id}"]`), ...form.querySelectorAll('[name="add"]')];
    buttons.forEach(n => { n.disabled = true; n.setAttribute('aria-busy', 'true'); });
    open(opener); setBusy(true); status.textContent = 'Adding to cart...';
    let added = false;
    try {
      await request('cart/add.js', { items: [{ id: Number(id), quantity }] }); added = true;
      render(await request('cart.js')); status.textContent = 'Added to your cart.';
    } catch (error) {
      status.textContent = added ? 'Your item was added, but the cart could not refresh. Close and reopen the cart to refresh it.' : error.message;
    } finally {
      setBusy(false); buttons.forEach(n => { n.disabled = false; n.removeAttribute('aria-busy'); });
    }
  }
  panel.querySelectorAll('[data-tl-cart-close]').forEach(button => button.addEventListener('click', close));
  panel.addEventListener('close', () => { document.documentElement.classList.remove('tl-cart-open'); if (trigger?.isConnected) trigger.focus(); });
  panel.addEventListener('click', event => { if (event.target !== panel) return; const r = panel.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); });
  panel.querySelector('.tl-cart-checkout').addEventListener('click', event => { if (busy) event.preventDefault(); });
  document.addEventListener('click', event => { const link = event.target.closest('.tl-cart-link'); if (link) { event.preventDefault(); show(link); } });
  window.TimelineCartUI = { add, show };
})();
